module.exports = __webpack_public_path__ + "static/media/error-notification-icon.367bccc6.svg";